import { Card } from "@/components/ui/card";
import type { Kurs, KursCategory } from "@/kursy/general";
import rachunkowosc from "@/assets/courses_category_image/rachunkowosc.png";
import doradcaPodatkowy from "@/assets/courses_category_image/doradca-podatkowy.png";
import pit from "@/assets/courses_category_image/pit.png";
import cit from "@/assets/courses_category_image/cit.png";
import citEston from "@/assets/courses_category_image/cit-eston.png";
import podstawyPrawaPodatkowego from "@/assets/courses_category_image/podstawy-prawa-podatkowego.png";
import kontrolePostep from "@/assets/courses_category_image/kontrole-postep.png";
import vat from "@/assets/courses_category_image/vat.png";
import podatkiOdPodstaw from "@/assets/courses_category_image/podatki-od-podstaw.png";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/components/utils/utils";

// Funkcja dobierająca grafikę na podstawie kategorii
const getCategoryImage = (category: KursCategory): string => {
	switch (category) {
		case "rachunkowosc":
			return rachunkowosc;
		case "doradca-podatkowy":
			return doradcaPodatkowy;
		case "pit":
			return pit;
		case "cit":
			return cit;
		case "cit-eston":
			return citEston;
		case "podstawy-prawa-podatkowego":
			return podstawyPrawaPodatkowego;
		case "kontrole-postep":
			return kontrolePostep;
		case "vat":
			return vat;
		case "podatki-od-podstaw":
			return podatkiOdPodstaw;
		default:
			return rachunkowosc; // domyślna grafika
	}
};

// Funkcja dobierająca dane badge'a na podstawie kategorii
const getCategoryBadgeData = (
	category: KursCategory
): { name: string; backgroundColor: string; textColor: string } | null => {
	switch (category) {
		case "vat":
			return { name: "VAT", backgroundColor: "#9F2232", textColor: "#FFFFFF" };
		case "pit":
			return { name: "PIT", backgroundColor: "#FCE243", textColor: "#FFFFFF" };
		case "cit":
			return { name: "CIT", backgroundColor: "#46B51F", textColor: "#FFFFFF" };
		case "cit-eston":
			return {
				name: "CIT estoński",
				backgroundColor: "#CDDB72",
				textColor: "#FFFFFF",
			};
		case "podstawy-prawa-podatkowego":
			return {
				name: "Podstawy prawa podatkowego",
				backgroundColor: "#76BEE2",
				textColor: "#FFFFFF",
			};
		case "kontrole-postep":
			return {
				name: "Kontrole i postępowania",
				backgroundColor: "#984807",
				textColor: "#FFFFFF",
			};
		case "rachunkowosc":
			return {
				name: "Rachunkowość",
				backgroundColor: "#009ADF",
				textColor: "#FFFFFF",
			};
		case "doradca-podatkowy":
			return {
				name: "Doradca podatkowy",
				backgroundColor: "#B27B48",
				textColor: "#FFFFFF",
			};
		case "podatki-od-podstaw":
			return {
				name: "Podatki od podstaw",
				backgroundColor: "#E8E8A1",
				textColor: "#FFFFFF",
			};
		default:
			return null; // Brak badge'a dla niezdefiniowanych kategorii lub null
	}
};

export const CourseTitleCard = ({ kurs }: { kurs: Kurs }): JSX.Element => {
	const badgeData = getCategoryBadgeData(kurs.category);
	const shouldShowBadge = badgeData && kurs.level !== "generalny";

	return (
		<Card
			className="relative z-0 min-h-[176px] bg-courseCardGradient flex flex-col justify-center items-center rounded-xl p-3"
			key={`CourseTitleCard--${kurs.slug}`}
		>
			{shouldShowBadge && (
				<div className="absolute top-2 left-2">
					<Badge
						style={{
							backgroundColor: badgeData.backgroundColor,
							color: badgeData.textColor,
						}}
					>
						{badgeData.name}
					</Badge>
				</div>
			)}
			<div className={cn("text-center", shouldShowBadge && "pt-4")}>
				<h2 className="font-roboto font-bold text-lg text-white">
					{kurs.title}
				</h2>
				{kurs.level && kurs.level !== "generalny" && (
					<p className="font-roboto font-light text-base text-white/90 capitalize mt-2">
						{kurs.level}
					</p>
				)}
			</div>
			<img
				alt="category"
				className="absolute bottom-0 right-0 h-full"
				src={getCategoryImage(kurs.category)}
			/>
		</Card>
	);
};
